import { setFouls, setFoulsOnPeriod, setGoals } from 'modules/overlay-v2/store/game-info/game-info';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store/store';
import { setPopupIsLoaded } from 'modules/overlay-v2/store/overlay/overlay';
import { setPeriod, setState, setTimer, toggleTimer } from 'modules/overlay-v2/store/time/time';

export interface PopupMessage {
  type: string;

  [key: string]: any;
}

export function useParsePopupMessage() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    window.addEventListener('message', receiveMessage, false);

    function receiveMessage(event: MessageEvent) {
      // Строгое равенство, а не `includes`: подстрока пропускала любой домен, для которого
      // наш origin — префикс (`https://admin.imgameapp.ru.example.com`). Такая страница
      // может открыть окно оверлея и слать в него команды — счёт сменится прямо в эфире.
      if (event.origin !== window.location.origin) return;

      try {
        const message: PopupMessage = JSON.parse(event.data);
        switch (message.type) {
          case 'setGoals': {
            dispatch(setGoals({ first: message?.first, second: message?.second }));
            break;
          }

          case 'setFouls': {
            dispatch(setFoulsOnPeriod({ first: message?.first, second: message?.second, period: message?.period }));
            break;
          }

          case 'setPeriod': {
            dispatch(setTimer({ milliseconds: 0 }));
            dispatch(setPeriod(message.period));
            break;
          }

          case 'toggleTimer': {
            dispatch(toggleTimer());
            break;
          }

          case 'setTimer': {
            dispatch(setTimer({ milliseconds: message.milliseconds }));
            break;
          }

          case 'syncState': {
            dispatch(setGoals(message.gameInfo.goals));
            // Раскладку фолов переносим как есть: ключи здесь — номера периодов, и лишний
            // ключ `period` только засорял бы её. Сам период приезжает ниже, в setState.
            dispatch(setFouls(message.gameInfo.fouls));
            dispatch(setState({ ...message.time, passedTime: message.timer }));
            break;
          }

          case 'popupLoaded': {
            dispatch(setPopupIsLoaded(true));
          }
        }
      } catch (e) {
        console.error(e, { data: event.data });
      }
    }

    return () => window.removeEventListener('message', receiveMessage, false);
  }, [dispatch]);
}
